import { render, staticRenderFns } from "./Client_Self_Assessment_Lab.vue?vue&type=template&id=46e609e4"
import script from "./Client_Self_Assessment_Lab.vue?vue&type=script&lang=js"
export * from "./Client_Self_Assessment_Lab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports